export default class DecodedObject {
    constructor(newPosition) {
        this.newPosition = newPosition;
    }
    getNewPosition() {
        return this.newPosition;
    }
}
